import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  administrationItems,
  navigationItems,
  settingsItems,
} from "@constants/NavigationMenu";
import { Box } from "@mui/material";
import NavigationMenu from "@shared-ui-components/NavigationMenu";
import LocationContext from "@src/context/location/locationContext";
import NotificationCountContext from "@src/context/NotificationCount/notificationCountContext";
import ShowErrorToastContext from "@src/context/showErrorToast/showErrorToastContext";

import { getNotificationCount } from "../DefaultLayout/helper";
import { StyledContainer } from "./styles";

interface NavigationProps {
  handleCloseDrawer?: () => void;
  handleOpenLogOutModal: () => void;
}

const SideBar = ({
  handleCloseDrawer,
  handleOpenLogOutModal,
}: NavigationProps) => {
  const navigate = useNavigate();
  const [{ notificationCountState }] = useContext(NotificationCountContext);
  const [{ locationState }] = useContext(LocationContext);
  const { property, store, revenueCenter, date } = locationState;
  const [{ notificationCountStateSetState }] = useContext(
    NotificationCountContext
  );
  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const handleRedirect = (pathname: string) => {
    if (pathname === "log-out") {
      if (handleOpenLogOutModal) handleOpenLogOutModal();
    } else {
      const url = pathname === "home" ? "/" : `/${pathname}`;
      navigate(url);
    }
    if (handleCloseDrawer) handleCloseDrawer();
  };

  const getData = async (filters: FilterType) => {
    const res = await getNotificationCount(filters);
    if (!res.error) {
      notificationCountStateSetState({ count: res?.data });
    } else {
      showErrorToastSetState({
        errorMessage: res.error || "",
        errorTitle: "Unable to Fetch Notification Count",
        open: true,
      });
    }
  };

  useEffect(() => {
    const filter: FilterType = {
      property,
      store,
      rvc: revenueCenter,
      date,
    };
    getData(filter);
  }, [property, store, revenueCenter, date]);

  return (
    <StyledContainer>
      <Box>
        <NavigationMenu
          title={administrationItems.title}
          options={administrationItems.options}
          handleClick={handleRedirect}
          newNotificationCount={0}
        />
      </Box>
      <Box>
        <NavigationMenu
          title={navigationItems.title}
          options={navigationItems.options}
          handleClick={handleRedirect}
          newNotificationCount={notificationCountState?.count}
        />
      </Box>
      <Box>
        <NavigationMenu
          title={settingsItems.title}
          options={settingsItems.options}
          handleClick={handleRedirect}
        />
      </Box>
    </StyledContainer>
  );
};

SideBar.defaultProps = {
  handleCloseDrawer: () => null,
};

export default SideBar;
